import { useState, useEffect } from "react";
import { X, Users } from "lucide-react";
import { cn } from "@/lib/utils";

const INITIAL_DELAY = 3000; // 3 seconds before showing
const DISPLAY_DURATION = 6000; // 6 seconds total display

export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Generate consistent count for the week (20-40 range)
  const weekSeed = Math.floor(Date.now() / (7 * 24 * 60 * 60 * 1000));
  const count = 20 + (weekSeed % 21); // 20-40

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    checkMobile();
    window.addEventListener("resize", checkMobile, { passive: true });
    
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, INITIAL_DELAY);

    return () => {
      clearTimeout(showTimer);
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  useEffect(() => {
    if (!isVisible || isDismissed) return;

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, DISPLAY_DURATION);

    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  // Hide on mobile
  if (isMobile || isDismissed) return null;

  return (
    <div
      className={cn(
        "fixed z-50 bottom-4 left-4 max-w-xs",
        "transition-all duration-300 ease-out",
        isVisible
          ? "translate-x-0 opacity-100"
          : "-translate-x-full opacity-0 pointer-events-none"
      )}
    >
      <div className="bg-card border border-border rounded-lg shadow-md px-3 py-2 flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-success/20 flex items-center justify-center flex-shrink-0">
          <Users className="h-3.5 w-3.5 text-success" />
        </div>
        <p className="text-xs font-medium text-foreground">
          <span className="font-semibold">{count}</span> teams signed up this week
        </p>
        <button
          onClick={handleDismiss}
          className="p-1 rounded hover:bg-muted transition-colors flex-shrink-0 ml-1"
          aria-label="Dismiss notification"
        >
          <X className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
};
